import $ from "jquery";
import prestashop from "prestashop";
class Owa {
  inviaForm(nomeform) {
    var f = document.forms[nomeform];
    var data = {};
    $("form[name='" + nomeform + "'] input, form[name='" + nomeform + "'] textarea, form[name='" + nomeform + "'] select").each(function(index, el) {
      data[$(el).prop("name")] = $(el).val();
    });
    var url = $("form[name='" + nomeform + "']").data("azione");
    if ($("#owapopcform").length == 1) {
      data["ajax"] = "1";
      console.log(data);
      console.log(url);
      $.ajax({
        url,
        type: "POST",
        cache: false,
        data,
        success: function(data2) {
          console.log("SUCCESS 1:");
          console.log(data2);
          var cf = jQuery(data2).find("#owamaincf");
          console.log("OWAMAINCF");
          console.log(cf.html());
          console.log(cf);
          $("#owapopcform .owacont").html(data2);
        }
      });
      console.log("INVIO ajx");
      event.preventDefault();
    } else {
      f.action = url;
      f.submit();
    }
  }
  mettiClickRequest() {
    console.log("metti click request");
    $(".owarequest").on("click", function() {
      console.log("Rquest");
      if ($("#owapopcform").length == 1) {
        var h = $("#main").height();
        if (h < 960) {
          h = 960;
        }
        $("#owapopcform").removeClass("nonvisibile");
        let modello = "";
        let idprod = $(this).data("id_product");
        let tipo = $(this).data("tipo");
        let modelloimg = "";
        if (tipo == "lista") {
          modello = $(this).data("owasku") + ": " + $(this).parents("article.product-miniature").children(".product-miniature__title").html();
          modelloimg = $(this).data("img");
        } else {
          modello = $("#owasku").html() + ": " + $("#owatitolo").html();
          let imgs = $(".js-product-images img");
          modelloimg = imgs.prop("src");
        }
        console.log(modello);
        console.log(modelloimg);
        console.log(idprod);
        $("#owapopcform #owatitolo").html(modello);
        $("#owapopcform #owadesc").html($("#product-description-short-" + idprod).html());
        $("#owapopcform #owamodelloimg").prop("src", modelloimg);
        $("#owapopcform #id_product").val(idprod);
        $("#owacontactcolsx").removeClass("col-md-12");
        $("#owacontactcolsx").addClass("col-md-8");
        setTimeout(function() {
          $("#owapopcform").css("height", "" + h + "px");
        }, 300);
      }
    });
    $("#owachiudicform").on("click", function() {
      if ($("#owapopcform").length == 1) {
        $("#owapopcform").css("height", "0");
        setTimeout(function() {
          $("#owapopcform").addClass("nonvisibile");
        }, 400);
      }
    });
  }
}
export default Owa;
